import React from 'react';

import cx from 'classnames';

import { useTooltipOffset } from '../../../utils/hooks';
import { LightTooltip } from '../LightTooltip';
import useStyles from './styles';

interface ProgressLineProps {
  width?: number;
  wrapperClass?: string;
  lineClass?: string;
  tooltipText?: string;
}

const ProgressLine: React.FC<ProgressLineProps> = ({
  width = 0,
  wrapperClass = '',
  lineClass = '',
  tooltipText = '',
}) => {
  const classes = useStyles();
  const [offset, wrapperRef, handleMouseEnter] = useTooltipOffset();

  return tooltipText ? (
    <LightTooltip
      placement="top"
      title={tooltipText}
      classes={{ tooltip: classes.tooltip }}
      PopperProps={{
        popperOptions: {
          modifiers: {
            offset: {
              enabled: true,
              offset: `${offset.x}px, 0px`,
            },
          },
        },
      }}
    >
      <div ref={wrapperRef} onMouseEnter={handleMouseEnter}>
        <div className={cx(classes.wrapper, wrapperClass)} />
        <div
          data-testid="progress"
          className={cx(classes.line, lineClass)}
          style={{ width: `${width}%` }}
        />
      </div>
    </LightTooltip>
  ) : (
    <>
      <div className={cx(classes.wrapper, wrapperClass)} />
      <div
        data-testid="progress"
        className={cx(classes.line, lineClass)}
        style={{ width: `${width}%` }}
      />
    </>
  );
};

export default ProgressLine;
